import { createAction } from 'redux-actions'

export const openCompass = createAction('OPEN_COMPASS')
export const closeCompass = createAction('CLOSE_COMPASS')

export const resetCompass = createAction('RESET_COMPASS')
